export const Chrome = () => {
    return (
        <div className="w-full h-full bg-white p-4">
            <div className="w-full h-10 bg-gray-100 rounded-t-lg flex items-center px-4">
                <div className="w-3 h-3 rounded-full bg-red-500 mr-2"></div>
                <div className="w-3 h-3 rounded-full bg-yellow-500 mr-2"></div>
                <div className="w-3 h-3 rounded-full bg-green-500 mr-2"></div>
                <div className="flex-1 h-6 bg-white rounded-full mx-2 px-4 text-sm flex items-center">https://www.google.com</div>
            </div>
            <div className="w-full h-[calc(100%-2.5rem)] flex items-center justify-center">
                <div className="text-center">
                    <div className="text-6xl font-bold mb-4">
                        <span className="text-blue-500">G</span>
                        <span className="text-red-500">o</span>
                        <span className="text-yellow-500">o</span>
                        <span className="text-blue-500">g</span>
                        <span className="text-green-500">l</span>
                        <span className="text-red-500">e</span>
                    </div>
                    <div className="w-96 h-10 mx-auto bg-white border rounded-full shadow-md flex items-center px-4">
                        <span className="text-gray-400">Search Google or type a URL</span>
                    </div>
                </div>
            </div>
        </div>
    );
};
